<!-- <app-navbar *ngIf="router.url != '/nao-encontrado'"></app-navbar> -->
<router-outlet></router-outlet>
<!-- <app-footer *ngIf="router.url != '/nao-encontrado'"></app-footer>
 -->
